export const hospitalDiagnosisColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'code',
  'description',
  'fk_hospital__data_doc_new_id',
  'is_scrubbed',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'on_admission__admission_code',
  'on_admission__admission_code_date',
  'on_admission__admission_code_flag',
  'post_date_time',
  'sequence',
  'snapshot_id',
  'type',
  'version',
];
